import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import home from '@/views/home.vue'
import all from '@/views/all/all.vue'
import liaowang from '@/views/liaowang/liaowang.vue'
import chengguan from '@/views/chengguan/chengguan.vue'
import zhujian from '@/views/zhujian/zhujian.vue'
import huanbao from '@/views/huanbao/huanbao.vue'
import qita from '@/views/qita/qita.vue'

Vue.use(Router)

export default new Router({
  mode:"hash",
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    /* {
         path: '/',
         name: 'home',
         component: HelloWorld
     },*/
    {
      path: '/home',
      name: 'home',
      component: home,
      children: [
        {
          path: '/',
          name: 'all',
          component: all,
          meta: {
            index: 1
          }
        },
        {
          path: '/all',
          name: 'all',
          component: all,
          meta: {
            index: 1
          }
        },
        {
          path: '/qita',
          name: 'qita',
          component: qita,
          meta: {
            index: 6
          }
        },
        {
          path: '/liaowang',
          name: 'liaowang',
          component: liaowang,
          meta: {
            index: 2
          }
        },
        {
          path: '/chengguan',
          name: 'chengguan',
          component: chengguan,
          meta: {
            index: 5
          }
        },
        {
          path: '/zhujian',
          name: 'zhujian',
          component: zhujian,
          meta: {
            index: 4
          }
        },
        {
          path: '/huanbao',
          name: 'huanbao',
          component: huanbao,
          meta: {
            index: 3
          }
        }
      ]
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js